export default "__VITE_ASSET__DYyQu$tC__"